<template>
<el-container>
  <publicHeader :currencyShow="currencyShow" @hotelLanguage="hotelLanguage" @getfirstName="getfirstName" v-if="ismobile === false"></publicHeader>
  <el-main>
    <div class="main" v-if="ismobile === false">
      <!--步骤条-->
      <div class="stepinfo">
          <div :class="'step-line-one-'+language">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div :class="'step-line-two-'+language">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div :class="'order-step-new-'+language" style="float: left;">
            <img class="step-img" src="https://res.roompai.com/static/img/order/y-one.png"> <span class="step-text">{{$t('hoteInformation')}}</span>
          </div>
          <div :class="'order-step-new-'+language">
            <img class="step-img" src="https://res.roompai.com/static/img/order/y-two.png"> <span class="step-text">{{$t('customerInformation')}}</span>
          </div>
          <div :class="'order-step-new-'+language" style="float: right;">
            <img class="step-img" src="https://res.roompai.com/static/img/order/b-three.png"> <span class="step-text">{{$t('finalStep')}}</span>
          </div>
        </div>
        <!--步骤条结束-->
      <div class="msg-main">
        <!--右侧部分-->
        <OrderRight :hotelOut="hotel" :orderDataOut="orderData" :source="source" :language="language" :ismobile="ismobile"  :TransactionFeeshowOut="TransactionFeeshow" :nowPageData="nowPageData" @getCouponInfo="getCouponInfo" :paymentOn="paymentOn"></OrderRight>
        <!--左侧部分-->
        <div class="msg-left">
          <!--登录/注册入口-->
          <div class="msg-blue" v-if="loginStatus">
            <div class="blue-tag">
              <div class='blue-back'>
                <img class="blue-logo" src="/static/img/order/pay-user.png">
              </div>
            </div>
            <div class="blue-text" style="width: 84%; white-space: nowrap;overflow: hidden;display: inline-flex;line-height: 50px;">
              <span class="blue-maintext" @click="login">{{$t('signIn')}}/{{$t('createAccounts')}}</span>
              <span>{{$t('signingYourAccountBooking')}}</span>
            </div>
          </div>
          <div class="msg-blue" v-else>
            <div class="blue-tag">
              <div class='blue-back'>
                <img class="blue-logo" src="/static/img/order/pay-user.png">
              </div>
            </div>
            <div class="blue-text" style="width: 90%; white-space: nowrap;overflow: hidden;display: inline-flex;line-height: 50px;">
              <div style="width: 50%;">
                <span style="padding: 0px 10px;">{{$t('hello')}} {{firstName}}</span>
              </div>
              <div style="width: 50%;text-align: right;color: #303133;">
                <span>{{$t('noThisUser')}}</span>
                <span style="color:#5392F9; font-weight:650; cursor: pointer;" @click="loginOut">{{$t('signOut')}}</span>
              </div>
            </div>
          </div>
          <!--倒计时-->
          <div class="msg-pink" :class="[{'msg-bule-show':loginStatus}]">
            <div class="pink-tag">
              <div class='pink-back'>
                <img class="pink-logo" src="/static/img/order/pay-hour.png">
              </div>
            </div>
            <div class="pink-text">
              <span>{{$t('please')}}</span>
              <span class="pink-maintext">
                  {{minuteString + ':'+ secondString}}
                </span>
              <span>{{$t('orderPaymentRight')}}</span>
            </div>
          </div>
          <!--住客资料-->
          <form class="el-form demo-ruleForm">
            <div class="msg-guest">
              <div style="padding: 2px 20px;">
                <p style="font-size:22px; font-weight:650;">{{$t('customerInformationDesc')}}</p>
                    <div>
                      <div style="font-size:14px; font-weight:650;">{{$t('roomName')}}</div>
                      <div style="margin-bottom:15px;" v-if="language === 'zh'">
                        <div class="msg-lastname" style="float:left;">
                          <div for="name" class="msg-name">{{$t('lastName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('userlastname1')}" ref="userlastname1" maxlength="40" @blur="blurs('userlastname1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('userlastname1')">
                              <span v-html="getLanguageHtml(userLastNameError,'userLastNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-username" style="margin-left:2%;">
                          <div for="name" class="msg-name">{{$t('firstName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username1')}" ref="username1" maxlength="40" @blur="blurs('username1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username1')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:15px;" v-else>
                        <div class="msg-username" style="float:left;">
                          <div for="name" class="msg-name">{{$t('firstName')}}: {{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username1')}" ref="username1" maxlength="40" @blur="blurs('username1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username1')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-lastname" style="margin-left:2%;">
                          <div for="name" class="msg-name">{{$t('lastName')}}: {{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('userlastname1')}" ref="userlastname1" maxlength="40" @blur="blurs('userlastname1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('userlastname1')">
                              <span v-html="getLanguageHtml(userLastNameError,'userLastNameError')"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:15px;">
                        <div for="name" class="msg-name">{{$t('emailAddr')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('emails')}" ref="emails" @blur="blurs('emails')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('emails')">
                            <span v-html="getLanguageHtml(emailError,'emailError')"></span>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:15px;">
                        <div class="msg-lastname" style="float:left;">
                          <div for="name" class="msg-name">{{$t('phoneNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input input-bor">
                              <el-select style="width:35%;" v-model="selectTel" :placeholder="$t('pleaseSelect')" @change="telChange" filterable>
                                <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                              </el-select>
                              <input style="width:63.5%;" type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('tel1')}" ref="tel1" @blur="blurs('tel1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('tel1')">
                              <span v-html="getLanguageHtml(telError,'telError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-username" style="margin-left:2%;">
                          <div for="name" class="msg-name">{{$t('nationality')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input input-bor">
                              <el-select style="width:100%;" v-model="selectNat[1]" filterable :placeholder="$t('pleaseSelect')">
                                <el-option v-for="item in nationalityOptions" :key="item.id" :label="item.country" :value="item.id">{{item.country}}</el-option>
                              </el-select>
                              <!-- <input type="text" autocomplete="off" ref="nationality" class="el-input__inner"> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--客房2 等等-->
                    <div v-if="guestRoomNum>1" v-for="n in guestRoomNum-1" v-bind:key="n" v-show="true">
                      <div style="margin-top:50px;">
                        <div style="font-size:14px; font-weight:650;">{{$t('roomName')}} {{n + 1}}</div>
                        <div style="margin-bottom:15px;" v-if="language === 'zh'">
                            <div class="msg-lastname">
                              <div for="name" class="msg-name">{{$t('lastName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <input type="text" :autofocus="inputCursor" class="el-input__inner" :ref="`userlastname${n+1}`" @blur="blursMore('userlastname'+(n+1), 'userlastnametwo'+(n+1))">
                                </div>
                                <div class="el-form-item__error" v-show="getSomeThing('userlastname'+(n+1))">{{$t('pleaseLastName')}}</div>
                                <div class="el-form-item__error" v-show="getSomeThing('userlastnametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                              </div>
                            </div>
                            <div class="msg-username">
                              <div for="name" class="msg-name">{{$t('firstName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :ref="`username${n+1}`" @blur="blursMore('username'+(n+1), 'usernametwo'+(n+1))">
                                </div>
                                <div class="el-form-item__error" v-show="getSomeThing('username'+(n+1))">{{$t('pleaseFirstName')}}</div>
                                <div class="el-form-item__error" v-show="getSomeThing('usernametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                              </div>
                            </div>
                          </div>
                          <div style="margin-bottom:15px;" v-else>
                            <div class="msg-username">
                              <div for="name" class="msg-name">{{$t('firstName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :ref="`username${n+1}`" @blur="blursMore('username'+(n+1), 'usernametwo'+(n+1))">
                                </div>
                                <div class="el-form-item__error" v-show="getSomeThing('username'+(n+1))">{{$t('pleaseFirstName')}}</div>
                                <div class="el-form-item__error" v-show="getSomeThing('usernametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                              </div>
                            </div>
                            <div class="msg-lastname">
                              <div for="name" class="msg-name">{{$t('lastName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <input type="text" :autofocus="inputCursor" class="el-input__inner" :ref="`userlastname${n+1}`" @blur="blursMore('userlastname'+(n+1), 'userlastnametwo'+(n+1))">
                                </div>
                                <div class="el-form-item__error" v-show="getSomeThing('userlastname'+(n+1))">{{$t('pleaseLastName')}}</div>
                                <div class="el-form-item__error" v-show="getSomeThing('userlastnametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                              </div>
                            </div>
                          </div>
                          <div style="margin-bottom:15px;">
                            <div class="msg-username">
                              <div for="name" class="msg-name">{{$t('nationality')}}</div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <el-select style="width:100%;" v-model="selectNat[n+1]" filterable :placeholder="$t('pleaseSelect')">
                                    <el-option v-for="item in telOptions" :key="item.id" :label="item.country" :value="item.id">{{item.country}}</el-option>
                                  </el-select>
                                  <!-- <input type="text" autocomplete="off" :ref="`nationality${n+1}`" class="el-input__inner"> -->
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
              </div>
            </div>
            <!--支付方式-->
            <form class="el-form demo-ruleForm">
              <div class="msg-guest">
                <div style="padding: 2px 20px;">
                  <el-tabs v-model="activeName">
                    <div class="msg-green">
                      <div :class="'green-text-'+language">
                        <img class="green-logo" src="/static/img/order/dun.png">
                        <span>{{$t('encryptedSecure')}}</span>
                      </div>
                    </div>
                    <!-- 电子支付 -->
                    <el-tab-pane :label="$t('payMethod')" name="electronicPayment">
                      <div>
                        <img v-for="item in paymentList" :key="item.value" :src="item.src" style="width:38px; height:25px; margin-right: 5px;">
                        <!-- <img src="/static/img/order/jcb.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/master.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/visa-cart.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/diners.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/discover.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/american.png" style="width:38px; height:25px; margin-right: 5px;"> -->
                      </div>
                      <div>
                        <div class="long-margin" style="margin-bottom: 20px;">
                          <div>
                            <div for="name" class="msg-name">{{$t('payMethod')}}: </div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <el-select v-model="paymentOn" placeholder="请选择" @change="changePayment(paymentOn)" ref="paymentSelect" style="width:70%">
                                  <el-option v-for="item in paymentList" :key="item.value" :label="getLanguageHtml(item,'paymentLabel')" :value="item.value">
                                    <span style="float: left"><img :src="item.src" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                    <span style="float: left;" v-html="getLanguageHtml(item,'paymentLabel')"></span>
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="long-margin">
                          <div>
                            <div for="name" class="msg-name"></div>
                            <div class="el-form-item__content">
                              <li style="line-height: 25px;" v-if="['paypal', 'alipay'].includes(paymentOn)">{{$t('youSelectPay')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabelShow')" style="font-weight: 400;color: #5392F9;"></span>{{$t('youWillBeForwardedTo')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabelShow')" style="font-weight: 400;color: #5392F9;"></span>{{$t('websiteToProceedWithThisTransaction')}}</li>
                              <li style="line-height: 25px;" v-if="discountTotalPriceCNY === ''">{{$t('theTotalAmountYouChanged')}}
                                <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'wechat'">{{orderData.totalPriceCNY}}</span>
                                <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'paypal' || paymentOn === 'pingpong' || paymentOn === 'credit-card'"><a v-if="TransactionFeeshow === true">{{transactionFeeInfo[paymentOn]['totalPPriceUSD']}}</a><a v-else>{{orderData.totalPriceUSD}}</a></span>
                                <span v-if="TransactionFeeshow === true">{{$t('TransactionFeeMsgFirst')}} {{transactionFeeInfo[paymentOn]['TFeeTagUSD']}} {{$t('TransactionFeeMsgLast')}}</span>
                              </li>
                              <li style="line-height: 25px;" v-if="discountTotalPriceCNY !== ''">{{$t('theTotalAmountYouChanged')}}
                                <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'wechat'">{{orderData.discountTotalPriceCNY}}</span>
                                <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'paypal' || paymentOn === 'pingpong' || paymentOn === 'credit-card'"><a v-if="TransactionFeeshow === true">{{discountFeeInfo[paymentOn]['discountTotalPriceUSD']}}</a><a v-else>{{orderData.discountTotalPriceUSD}}</a></span>
                                <span v-if="TransactionFeeshow === true">{{$t('TransactionFeeMsgFirst')}} {{discountFeeInfo[paymentOn]['discountTFeeTagUSD']}} {{$t('TransactionFeeMsgLast')}}</span>
                              </li>
                            </div>
                          </div>
                        </div>
                        <div class="long-margin"></div>
                      </div>
                    </el-tab-pane>

                    <!-- 已存信用卡 -->
                    <el-tab-pane :label="$t('mySavedCards')" name="saveCard" v-if="payment_card_show && payment.total.status === '1'">
                      <div>
                        <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;" v-if="payment.total.typeLs.includes('visa')">
                        <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;" v-if="payment.total.typeLs.includes('master')">
                      </div>
                      <div>
                        <div class="long-margin">
                          <div class="msginfo-left">
                            <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <el-select v-model="paymentCardno" placeholder="请选择" @change="changePaymentCardno(paymentCardno)" ref="paymentCardno" style="width:100%">
                                  <el-option v-for="item in payment.list" :key="item.sign" :label="item.cardno" :value="item.sign">
                                    <span style="float: left" v-if="item.type === 'visa'"><img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                    <span style="float: left" v-if="item.type === 'master'"><img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                    <span style="float: left;" v-html="item.cardno"></span>
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                          <div class="msginfo-right">
                            <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input is-disabled">
                                <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoName">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="padding-bottom:80px;">
                          <div class="msg-half-one">
                            <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input is-disabled">
                                <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoEffectivedate">
                              </div>
                            </div>
                          </div>
                          <div class="msg-half">
                            <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShow}" ref="securityCode" @blur="blursCode('securityCode')" @click="showCardRemindInfo">
                              </div>
                              <div class="el-form-item__error" v-show="securityCodeShow">{{$t('validCVV')}}</div>
                            </div>
                          </div>
                          <div class="cardremind" v-show="showCardRemind">
                            <div class="remindimg">
                              <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                            </div>
                            <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <!-- 信用卡/借记卡 -->
                    <el-tab-pane :label="$t('creditDebitCard')" name="newCard" v-if="payment_card_show">
                      <div>
                        <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;display:inline-block;">
                        <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;">
                      </div>
                      <div>
                        <div class="long-margin">
                          <div class="msginfo-left">
                            <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username')}" ref="username" @blur="blurs('username')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('username')">
                                <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                              </div>
                            </div>
                          </div>
                          <div class="msginfo-right">
                            <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno')}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('cardno')">
                                <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="padding-bottom:40px;">
                          <div class="msg-half-one">
                            <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" autocomplete="off" class="el-input__inner" placeholder="MM/YY" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('effectivedate')">
                                <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                              </div>
                            </div>
                          </div>
                          <div class="msg-half">
                            <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShowTwo}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')">
                                <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                              </div>
                            </div>
                          </div>
                          <div class="cardremind" v-show="showCardRemindTwo">
                            <div class="remindimg">
                              <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                            </div>
                            <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                          </div>
                        </div>
                        <div style="height:30px;">
                          <el-checkbox v-model="checked">{{$t('rememberCard')}}</el-checkbox>
                        </div>
                      </div>
                    </el-tab-pane>

                  </el-tabs>
                </div>
              </div>
            </form>
            <!--特殊要求-->
            <div class="msg-guest">
              <div style="padding: 2px 20px;">
                <p style="font-size:16px; font-weight:650;">{{$t('haveSpecialRequests')}}</p>
                <p style="font-size:14px;">{{$t('specialRequestsAreGuaranteed')}}</p>
                <p style="font-size:14px;" v-if="secSpecialHotelJudge">{{$t('secSpecialRequestsAreGuaranteed')}}</p>
                <p style="font-size:12px; color:rgb(83, 146, 249)">{{$t('placeEnterTexteEnglish')}}</p>
                <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements"  @input="checkSpecial" maxlength="200" show-word-limit class="el-input__inner specialText"  v-if="language === 'en'"></el-input>
                <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements" maxlength="200" show-word-limit class="el-input__inner specialText"  v-else></el-input>
                </div>
            </div>
            <!--订房须知-->
            <div class="msg-guest" v-if="orderData.hotelFeesEnText !== ''">
              <div style="padding: 2px 20px;">
                <p style="font-size:16px; font-weight:650;">{{$t('bookingNotice')}}</p>
                <p style="font-size:14px;" class="hotelFeesText" v-if="language === 'en'" v-html="orderData.hotelFeesEnText"></p>
                <p style="font-size:14px;" class="hotelFeesText" v-if="language === 'zh'" v-html="orderData.hotelFeesZhText"></p>
              </div>
            </div>
            <!--去支付-->
            <div class="msg-guest" style="margin-bottom: 20px;">
              <div class="tonext">
                <p class="remind-font">
                  <el-checkbox v-model="clausePolicyChecked" @change="clausePolicyCheckedChange">
                    <span v-html="getLanguageHtml('','agreeToRoompai')"></span>
                    <router-link :to="{name:'clause', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="remind-text" target="_blank"> <span @click="linkClick('clause')">{{$t('termsOfUse')}}</span> </router-link> {{$t('and')}}
                    <router-link :to="{name:'policy', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="remind-text" target="_blank"> <span @click="linkClick('policy')">{{$t('privacyPolicy')}}</span> </router-link>
                  </el-checkbox>
                </p>
                <p style="font-size:12px; font-weight:500; color: #2F7000;height: 17px;line-height: 17px;" v-if="cancelData !== 0">
                  <img src="https://res.roompai.com/static/img/order/2F7000.png" style="width:17px; height:17px;vertical-align: text-bottom;">
                  {{$t('riskFree')}} <span v-html="getLanguageHtml(orderData.cancelData,'cancelData')"></span> {{$t('noCancelFeeBefore')}}
                </p>
                <p class="surplus-room" v-if="orderData.remainrooms === '1'">{{$t('onlyLast')}} 1 {{$t('onOurSite')}}</p>
                <p class="surplus-room" v-if="!clausePolicyChecked && jumpNextClickError">{{$t('pleaseTickTheCheckbox')}}</p>
                <p class="surplus-room" v-if="secSpecialHotelJudge && secSpecialHotelJudgeError">{{$t('secSpecialRequestsAreGuaranteedAlert')}}</p>
                <el-button class="order_button" @click="JumpNext">{{$t('goPay')}}</el-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="main" v-else>
      <!--步骤条-->
      <div class="stepinfo" :style="{ width: `${elementWidth}px` }">
        <div :style="{ width: `${stepWidth}px`}" style="margin: auto;">
          <div  :style="{ width: `${lineWidth}px`, left: `${lineOneLeft}px` }" style="position:relative; top: 12.5px;">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div  :style="{ width: `${lineWidth}px`, left: `${lineTwoLeft}px` }" style="position:relative; top:12.5px;">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div :class="'order-step-new-'+language" style="float: left;">
            <div><img class="step-img" src="https://res.roompai.com/static/img/order/y-one.png"></div>
            <div><span class="step-text">{{$t('hoteInformation')}}</span></div>
          </div>
          <div :class="'order-step-new-'+language">
            <div><img class="step-img" src="https://res.roompai.com/static/img/order/y-two.png"></div>
            <div><span class="step-text">{{$t('customerInformation')}}</span></div>
          </div>
          <div :class="'order-step-new-'+language" style="float: right;">
            <div><img class="step-img" src="https://res.roompai.com/static/img/order/b-three.png"></div>
            <div><span class="step-text">{{$t('finalStep')}}</span></div>
          </div>
        </div>
      </div>
      <!--步骤条结束-->
      <div style="clear:both"></div>
      <div class="mobile-msg-main">
        <div>
          <!--登录/注册入口-->
          <div class="mobile-msg-blue" v-if="loginStatus">
            <div class="blue-tag">
              <div class='blue-back'>
                <img class="blue-logo" src="/static/img/order/pay-user.png">
              </div>
            </div>
            <div class="blue-text" style="height: 35px; line-height: 17.5px; margin: 7.5px 0px 7.5px 10px; float: left; overflow: hidden;">
              <span class="blue-maintext" @click="login">{{$t('signIn')}}/{{$t('createAccounts')}}</span>
              <span>{{$t('signingYourAccountBooking')}}</span>
            </div>
          </div>
          <div class="mobile-msg-blue" v-else>
            <div class="blue-tag">
              <div class='blue-back'>
                <img class="blue-logo" src="/static/img/order/pay-user.png">
              </div>
            </div>
            <div class="blue-text">
              <span style="float:left;">{{$t('hello')}} {{firstName}}</span>
              <span style="float:right; font-size: 12px;">
                <span style="color: #303133;">{{$t('noThisUser')}}</span>
                <span style="color:#5392F9; font-weight:650; cursor: pointer;" @click="loginOut">{{$t('signOut')}}</span>
              </span>
            </div>
          </div>
          <!--倒计时-->
          <div class="msg-orange" :class="[{'msg-bule-show':loginStatus}]">
            <div class="orange-tag">
              <div class='orange-back'>
                <img class="orange-logo" src="/static/img/order/pay-hour.png">
              </div>
            </div>
            <div class="orange-text" style="height: 35px; line-height: 17.5px; margin: 7.5px 0px 7.5px 10px;float: left;">
              <div>{{$t('please')}}</div>
              <div class="orange-maintext" style="width:40px; text-align:center; ">{{minuteString + ':' + secondString}}</div>
              <span>{{$t('fillUpAllPriceDiff')}}</span>
            </div>
          </div>
        </div>
        <!--右侧部分-->
        <OrderRight :hotelOut="hotel" :orderDataOut="orderData" :source="source" :language="language" :ismobile="ismobile" :TransactionFeeshowOut="TransactionFeeshow" :nowPageData="nowPageData" @getCouponInfo="getCouponInfo" :paymentOn="paymentOn"></OrderRight>
        <!--左侧部分-->
        <div class="msg-left">
          <!--住客资料-->
          <form class="el-form demo-ruleForm">
            <div class="msg-guest">
              <div class="advanceText">{{$t('customerInformationDesc')}}</div>
                <div style="padding: 10px 4.5% 0px 4.5%;">
                    <div>
                      <div style="font-size:14px; font-weight:650;">{{$t('roomName')}}</div>
                      <div style="margin-bottom:20px;" v-if="language === 'zh'">
                        <div class="msg-lastname">
                          <div for="name" class="msg-name">{{$t('lastName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('userlastname1')}" ref="userlastname1" maxlength="40" @blur="blurs('userlastname1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('userlastname1')">
                              <span v-html="getLanguageHtml(userLastNameError,'userLastNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('firstName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username1')}" ref="username1" maxlength="40" @blur="blurs('username1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username1')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:20px;" v-else>
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('firstName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username1')}" ref="username1" maxlength="40" @blur="blurs('username1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('username1')">
                              <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-lastname">
                          <div for="name" class="msg-name">{{$t('lastName')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('userlastname1')}" ref="userlastname1" maxlength="40" @blur="blurs('userlastname1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('userlastname1')">
                              <span v-html="getLanguageHtml(userLastNameError,'userLastNameError')"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:20px;">
                        <div for="name" class="msg-name">{{$t('emailAddr')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" autocomplete="off" :autofocus="inputCursor" class="el-input__inner" :class="{'codeError':getSomeThing('emails')}" ref="emails" @blur="blurs('emails')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('emails')">
                            <span v-html="getLanguageHtml(emailError,'emailError')"></span>
                          </div>
                        </div>
                      </div>
                      <div style="margin-bottom:20px;">
                        <div class="msg-lastname">
                          <div for="name" class="msg-name">{{$t('phoneNumber')}}<span style="color:red;">*</span></div>
                          <div class="el-form-item__content">
                            <div class="el-input input-bor">
                              <el-select style="width:35%;" v-model="selectTel" :placeholder="$t('pleaseSelect')" @change="telChange">
                                <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                              </el-select>
                              <input style="width:63%;" type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('tel1')}" ref="tel1" @blur="blurs('tel1')">
                            </div>
                            <div class="el-form-item__error" v-show="getSomeThing('tel1')">
                              <span v-html="getLanguageHtml(telError,'telError')"></span>
                            </div>
                          </div>
                        </div>
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('nationality')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input input-bor">
                              <el-select style="width:100%;" v-model="selectNat[1]" filterable :placeholder="$t('pleaseSelect')">
                                <el-option v-for="item in telOptions" :key="item.id" :label="item.country" :value="item.id">{{item.country}}</el-option>
                              </el-select>
                              <!-- <input type="text" autocomplete="off" ref="nationality" class="el-input__inner"> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--客房2 等等-->
                    <div v-if="guestRoomNum>1" v-for="n in guestRoomNum-1" v-bind:key="n" v-show="true">
                      <div style="margin-top:50px;">
                        <div style="font-size:14px; font-weight:650;">{{$t('roomName')}} {{n + 1}}</div>
                        <div style="margin-bottom:20px;" v-if="language === 'zh'">
                            <div class="msg-lastname">
                              <div for="name" class="msg-name">{{$t('lastName')}}<span style="color:red;">*</span></div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <input type="text" :autofocus="inputCursor" class="el-input__inner" :ref="`userlastname${n+1}`" @blur="blursMore('userlastname'+(n+1), 'userlastnametwo'+(n+1))">
                                </div>
                                <div class="el-form-item__error" v-show="getSomeThing('userlastname'+(n+1))">{{$t('pleaseLastName')}}</div>
                                <div class="el-form-item__error" v-show="getSomeThing('userlastnametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                              </div>
                            </div>
                            <div class="msg-username">
                              <div for="name" class="msg-name">{{$t('firstName')}}<span style="color:red;">*</span></div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :ref="`username${n+1}`" @blur="blursMore('username'+(n+1), 'usernametwo'+(n+1))">
                                </div>
                                <div class="el-form-item__error" v-show="getSomeThing('username'+(n+1))">{{$t('pleaseFirstName')}}</div>
                                <div class="el-form-item__error" v-show="getSomeThing('usernametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                              </div>
                            </div>
                          </div>
                          <div style="margin-bottom:20px;" v-else>
                            <div class="msg-username">
                              <div for="name" class="msg-name">{{$t('firstName')}}<span style="color:red;">*</span></div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <input type="text" :autofocus="inputCursor" autocomplete="off" class="el-input__inner" :ref="`username${n+1}`" @blur="blursMore('username'+(n+1), 'usernametwo'+(n+1))">
                                </div>
                                <div class="el-form-item__error" v-show="getSomeThing('username'+(n+1))">{{$t('pleaseFirstName')}}</div>
                                <div class="el-form-item__error" v-show="getSomeThing('usernametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                              </div>
                            </div>
                            <div class="msg-lastname">
                              <div for="name" class="msg-name">{{$t('lastName')}}<span style="color:red;">*</span></div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <input type="text" :autofocus="inputCursor" class="el-input__inner" :ref="`userlastname${n+1}`" @blur="blursMore('userlastname'+(n+1), 'userlastnametwo'+(n+1))">
                                </div>
                                <div class="el-form-item__error" v-show="getSomeThing('userlastname'+(n+1))">{{$t('pleaseLastName')}}</div>
                                <div class="el-form-item__error" v-show="getSomeThing('userlastnametwo'+(n+1))">{{$t('pleaseTextEnglish')}}</div>
                              </div>
                            </div>
                          </div>
                          <div style="margin-bottom:20px;">
                            <div class="msg-username">
                              <div for="name" class="msg-name">{{$t('nationality')}}</div>
                              <div class="el-form-item__content">
                                <div class="el-input">
                                  <el-select style="width:100%;" v-model="selectNat[n+1]" filterable :placeholder="$t('pleaseSelect')">
                                    <el-option v-for="item in telOptions" :key="item.id" :label="item.country" :value="item.id">{{item.country}}</el-option>
                                  </el-select>
                                  <!-- <input type="text" autocomplete="off" :ref="`nationality${n+1}`" class="el-input__inner"> -->
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
              </div>
            </div>
            <!--支付方式-->
            <div class="msg-right">
              <div class="advanceText">{{$t('payMethod')}}</div>
              <div class="advanceInfo">
                <div>
                  <img v-for="item in paymentMobileList" :key="item.value" :src="item.src" style="width:38px; height:25px; margin-right: 5px;">
                </div>
                <div>
                  <div class="long-margin" style="margin-bottom: 20px;">
                    <div>
                      <div for="name" class="msg-name">{{$t('payMethod')}}<span style="color:red;">*</span></div>
                      <div class="el-form-item__content">
                        <div class="el-input">
                          <el-select v-model="paymentOn" placeholder="请选择" @change="changePaymentMobile(paymentOn)" ref="paymentSelectMobile" class="paymentSelectMobile" style="width:100%">
                            <el-option v-for="item in paymentMobileList" :key="item.value" :label="getLanguageHtml(item,'paymentLabel')" :value="item.value" v-if="item.value !== 'saveCard' || (item.value === 'saveCard' && payment.total.status === '1')">
                              <span style="float: left"><img :src="item.src" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                              <span style="float: left;" v-html="getLanguageHtml(item,'paymentLabel')"></span>
                              <span style="float: right" v-if="['saveCard', 'newCard'].includes(item.value)">
                                  <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle; margin-left: 5px;" v-if="item.value === 'newCard' || (item.value === 'saveCard' && payment.total.typeLs.includes('visa'))">
                                  <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle; margin-left: 5px;" v-if="item.value === 'newCard' || (item.value === 'saveCard' && payment.total.typeLs.includes('master'))">
                                </span>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div class="msg-green">
                        <div :class="'green-text-'+language">
                          <img class="green-logo" src="/static/img/order/dun.png">
                          <span>{{$t('encryptedSecure')}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="long-margin" v-show="['paypal', 'alipay', 'wechat', 'pingpong'].includes(paymentOn)">
                    <div>
                      <div for="name" class="msg-name"></div>
                      <div class="el-form-item__content">
                        <li style="line-height: 25px;font-size: 12px;" v-if="['paypal', 'alipay'].includes(paymentOn)">{{$t('youSelectPay')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabel')" style="font-weight: 400;color: #5392F9;"></span>{{$t('youWillBeForwardedTo')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabel')" style="font-weight: 400;color: #5392F9;"></span>{{$t('websiteToProceedWithThisTransaction')}}</li>
                        <li style="line-height: 25px;font-size: 12px;" v-if="discountTotalPriceCNY === ''">{{$t('theTotalAmountYouChanged')}} <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'wechat'">{{orderData.totalPriceCNY}}</span><span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'paypal' || paymentOn === 'pingpong'"><a v-if="TransactionFeeshow === true">{{transactionFeeInfo[paymentOn]['totalPPriceUSD']}}</a><a v-else>{{orderData.totalPriceUSD}}</a></span><span v-if="TransactionFeeshow === true">{{$t('TransactionFeeMsgFirst')}} {{transactionFeeInfo[paymentOn]['TFeeTagUSD']}} {{$t('TransactionFeeMsgLast')}}</span></li>
                        <li style="line-height: 25px;font-size: 12px;" v-if="discountTotalPriceCNY !== ''">{{$t('theTotalAmountYouChanged')}} <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'wechat'">{{orderData.discountTotalPriceCNY}}</span><span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'paypal' || paymentOn === 'pingpong'"><a v-if="TransactionFeeshow === true">{{discountFeeInfo[paymentOn]['discountTotalPriceUSD']}}</a><a v-else>{{orderData.discountTotalPriceUSD}}</a></span><span v-if="TransactionFeeshow === true">{{$t('TransactionFeeMsgFirst')}} {{discountFeeInfo[paymentOn]['discountTFeeTagUSD']}} {{$t('TransactionFeeMsgLast')}}</span></li>
                      </div>
                    </div>
                  </div>
                  <div class="long-margin" v-show="['saveCard'].includes(paymentOn)">
                    <div class="long-margin">
                      <div class="msginfo-right">
                        <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <el-select v-model="paymentCardno" placeholder="请选择" @change="changePaymentCardnoMobile(paymentCardno)" ref="paymentCardnoMobile" class="paymentCardnoMobileClass" style="width:100%">
                              <el-option v-for="item in payment.list" :key="item.sign" :label="item.cardno" :value="item.sign">
                                <span style="float: left" v-if="item.type === 'visa'"><img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                <span style="float: left" v-if="item.type === 'master'"><img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                <span style="float: left;" v-html="item.cardno"></span>
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div class="msginfo-left">
                        <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input is-disabled">
                            <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoName">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="padding-bottom:80px; position: relative;height: 20px;">
                      <div class="msg-half" style="width: 46%;position: absolute;">
                        <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input is-disabled">
                            <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoEffectivedate">
                          </div>
                        </div>
                      </div>
                      <div class="msg-half" style="width: 46%;position: absolute;right: 0px;">
                        <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShow}" ref="securityCode" @blur="blursCode('securityCode')" @click="showCardRemindInfo" @keyup.enter="closeCardRemind">
                          </div>
                          <div class="el-form-item__error" v-show="securityCodeShow">{{$t('validCVV')}}</div>
                        </div>
                      </div>
                      <div class="cardremind" v-show="showCardRemind">
                        <div class="remindimg">
                          <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                        </div>
                        <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="long-margin" v-show="['newCard'].includes(paymentOn)">
                    <div class="long-margin">
                      <div class="msginfo-left">
                        <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('username')}" ref="username" @blur="blurs('username')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('username')">
                            <span v-html="getLanguageHtml(userNameError,'userNameError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="msginfo-right">
                        <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno'), 'paymentCardnoMobileClass': true}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('cardno')">
                            <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="padding-bottom:40px;position: relative;">
                      <div class="msg-half">
                        <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" autocomplete="off" class="el-input__inner" placeholder="MM/YY" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('effectivedate')">
                            <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="msg-half">
                        <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShowTwo}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo" @keyup.enter="closeCardRemind">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')">
                            <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="cardremind" v-show="showCardRemindTwo">
                        <div class="remindimg">
                          <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                        </div>
                        <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                      </div>
                    </div>
                    <div style="height:30px;">
                      <el-checkbox v-model="checked">{{$t('rememberCard')}}</el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--特殊要求-->
            <div class="msg-guest">
              <div class="advanceText">{{$t('haveSpecialRequests')}}</div>
              <div style="padding: 10px 4.5% 0px 4.5%;">
                <p style="font-size:14px;">{{$t('specialRequestsAreGuaranteed')}}</p>
                <p style="font-size:14px;" v-if="secSpecialHotelJudge">{{$t('secSpecialRequestsAreGuaranteed')}}</p>
                <p style="font-size:12px; color:rgb(83, 146, 249)">{{$t('placeEnterTexteEnglish')}}</p>
                <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements"  @input="checkSpecial" maxlength="200" show-word-limit class="el-input__inner specialText"  v-if="language === 'en'"></el-input>
                <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements" maxlength="200" show-word-limit class="el-input__inner specialText"  v-else></el-input>
              </div>
            </div>
            <!--订房须知-->
            <div class="hotel-detail-info-mobile" v-if="orderData.hotelFeesEnText !== ''">
              <el-card class="box-card hotel-data-info">
                <div class="hotel-data-info-top" @click="mobileOverview = !mobileOverview">
                  <div class="hotel-overview-text">{{$t('bookingNotice')}}</div>
                  <div class="hotel-overview-img">
                    <img src="/static/img/hotelsearch/drop-down.png" alt="" v-if="mobileOverview === false">
                    <img src="/static/img/hotelsearch/drop-up.png" alt="" v-if="mobileOverview === true">
                  </div>
                </div>
                <div class="hotel-data-info-bottom" v-if="mobileOverview === true">
                  <p style="font-size:14px;" class="hotelFeesText" v-if="language === 'en'" v-html="orderData.hotelFeesEnText"></p>
                  <p style="font-size:14px;" class="hotelFeesText" v-if="language === 'zh'" v-html="orderData.hotelFeesZhText"></p>
                </div>
              </el-card>
            </div>
            <!--前往最后一步-->
            <div class="msg-guest" style="margin-bottom: 20px;">
              <div class="tonext">
                <p class="remind-font">
                  <el-checkbox v-model="clausePolicyChecked" @change="clausePolicyCheckedChange">
                    <span v-html="getLanguageHtml('','agreeToRoompai')"></span> <a class="remind-text" @click="linkClick('clause', '2')">{{$t('termsUse')}}</a> {{$t('and')}} <a class="remind-text" @click="linkClick('policy', '2')">{{$t('privacyPolicy')}}</a>
                  </el-checkbox>
                </p>
                <p style="font-size:12px; font-weight:500; color: #2F7000;line-height: 17px; margin-bottom: 5px;" v-if="cancelData !== 0">
                  <img src="https://res.roompai.com/static/img/order/2F7000.png" style="width:17px; height:17px;vertical-align: text-bottom;">{{$t('mobileRiskFreeOne')}}<br>
                  <span v-if="language === 'en'">{{$t('mobileRiskFreeTwo')}} </span>
                  <span v-else>{{$t('mobileRiskFreeTwo')}}</span>
                  <span v-html="getLanguageHtml(orderData.cancelData,'cancelData')"></span> {{$t('noCancelFeeBefore')}}
                </p>
                <p class="surplus-room" v-if="orderData.remainrooms === '1'">{{$t('onlyLast')}} 1 {{$t('onOurSite')}}!</p>
                <p class="surplus-room" v-if="!clausePolicyChecked && jumpNextClickError">{{$t('pleaseTickTheCheckbox')}}</p>
                <p class="surplus-room" v-if="secSpecialHotelJudge && secSpecialHotelJudgeError">{{$t('secSpecialRequestsAreGuaranteedAlert')}}</p>
                <el-button class="order_button" @click="JumpNext">{{$t('goPay')}}</el-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <frameRefresh :frameDialog="frameDialog"></frameRefresh>
    <frameHotelSold :frameHotelSoldDialog="frameHotelSoldDialog" :checkIn="checkIn" :checkOut="checkOut"></frameHotelSold>
    <frameHotelSoldEn :frameHotelSoldEnDialog="frameHotelSoldEnDialog" :checkIn="checkIn" :checkOut="checkOut"></frameHotelSoldEn>
    <frameHomeSold :frameHomeSoldDialog="frameHomeSoldDialog"></frameHomeSold>
    <frameRise :frameRiseDialog="frameRiseDialog" :risePrice="risePrice" :curPageData="curPageData" @frameRiseBookingFun="frameRiseBookingFun" @frameRiseBookingBackFun="frameRiseBookingBackFun"></frameRise>
    <frameQuotation :frameQuotationDialog="frameQuotationDialog" @continueBookingFun="continueBookingFun"></frameQuotation>
    <frameConinueOrder :frameConinueOrderDialog="frameConinueOrderDialog" @continueBookingFun="continueBookingFun"></frameConinueOrder>
    <frameLast :frameLastDialog="frameLastDialog" :homeSurplus="homeSurplus"></frameLast>
    <frameRemind :frameRemindDialog="frameRemindDialog" @continueBookingFun="continueBookingFun"></frameRemind>
    <frameToolong :frameToolongDialog="frameToolongDialog"></frameToolong>
    <frameNetwork :frameNetworkDialog="frameNetworkDialog"></frameNetwork>
    <frameNotice :frameNoticeDialog="frameNoticeDialog" @frameNoticeFun="frameNoticeFun"></frameNotice>
    <mobilepolicy :policyDialog="policyDialog" @getPolicyDia="getPolicyDia"></mobilepolicy>
    <mobileclause :clauseDialog="clauseDialog" @getClauseDia="getClauseDia"></mobileclause>
    <publicMask :fullscreenLoading="fullscreenLoading"></publicMask>
    <frameChangeRoom :frameChangeRoomDialog="frameChangeRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :curPageData="curPageData" @frameChangeRoomBookingFun="frameChangeRoomBookingFun" @frameChangeRoomBookingBackFun="frameChangeRoomBookingBackFun"></frameChangeRoom>
    <frameChangePriceAndRoom :frameChangePriceAndRoomDialog="frameChangePriceAndRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :curPageData="curPageData" :risePrice="risePrice" @frameChangePriceAndRoomBookingFun="frameChangePriceAndRoomBookingFun" @frameChangePriceAndRoomBookingBackFun="frameChangePriceAndRoomBookingBackFun"></frameChangePriceAndRoom>
    <NoPayOrderPop :Overlay="true" :onlyCheckHotelId="true" :hotelId="this.hotelid"></NoPayOrderPop>
    <mobileLoginBindPop :conver="conver" :popShow="this.mobileLoginBindPopShow" :actionSetup="this.mobileLoginBindPopAction" :telOptionsSetup="this.telOptions" :selectTelSetup="this.selectTel" :source="this.source" :language="this.language" :site="this.getSite" @closepop="mobileLoginBindPopCloseSetup"></mobileLoginBindPop>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { orderBookVerify, writeOrderShow, orderFillCosInfo } from '@/request/order.js'
import { signIn } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import frameRefresh from '@/components/public/frameRefresh'
import frameHotelSold from '@/components/public/frameHotelSold'
import frameHotelSoldEn from '@/components/public/frameHotelSoldEn'
import frameHomeSold from '@/components/public/frameHomeSold'
import frameRise from '@/components/public/frameRise'
import frameQuotation from '@/components/public/frameQuotation'
import frameLast from '@/components/public/frameLast'
import frameRemind from '@/components/public/frameRemind'
import frameToolong from '@/components/public/frameToolong'
import frameNetwork from '@/components/public/frameNetwork'
import frameNotice from '@/components/public/frameNotice'
import mobilepolicy from '@/components/question/mobilepolicy'
import mobileclause from '@/components/question/mobileclause'
import OrderRight from '@/components/order/module/OrderRight'
import publicMask from '@/components/public/publicMask'
import frameChangeRoom from '@/components/public/frameChangeRoom'
import frameChangePriceAndRoom from '@/components/public/frameChangePriceAndRoom'
import NoPayOrderPop from '@/components/order/module/NoPayOrderPop'
import mobileLoginBindPop from '@/components/login/module/mobileLoginBindPop'
import frameConinueOrder from '@/components/public/frameConinueOrder'

export default {
  name: 'WriteOrder',
  components: {
    publicFooter,
    publicHeader,
    frameRefresh,
    frameHotelSold,
    frameHotelSoldEn,
    frameHomeSold,
    frameRise,
    frameQuotation,
    frameLast,
    frameRemind,
    frameToolong,
    frameNetwork,
    frameNotice,
    mobilepolicy,
    mobileclause,
    OrderRight,
    publicMask,
    frameChangeRoom,
    frameChangePriceAndRoom,
    NoPayOrderPop,
    mobileLoginBindPop,
    frameConinueOrder
  },
  data () {
    return {
      curPageData: 'WriteOrder',
      nowPageData: 'bookingWriteOrder',
      hotelid: 0,
      hotel: {},
      orderData: {'roomName': {'zh': '', 'en': ''}, 'cancel': {'zh': '', 'en': ''}, 'night': {'zh': 1, 'en': 1}, 'roomNum': {'zh': 1, 'en': 1}, 'mandatoryFee': '', 'mandatoryTax': '', 'resortFee': '', 'payAtProperty': ''},
      remainTime: 300,
      guestRoomNum: 2,
      guestRoomMore: false,
      someArray: [],
      userLastNameError: 'pleaseLastName',
      userNameError: 'pleaseFirstName',
      emailError: 'pleaseEnterYourEmailOrYouMightMissBooking',
      telError: 'pleaseValidPhone',
      emailConfirmError: 'pleaseEmailFieldsMatch',
      desc: '',
      telOptions: [{id: 216, value: '美国 +1', telnum: 'US +1'}, {id: 42, value: '中国 +0086', telnum: 'CN +86'}],
      nationalityOptions: [{id: 216, value: '美国 +1', telnum: 'US +1'}, {id: 42, value: '中国 +0086', telnum: 'CN +86'}],
      selectTel: '216',
      selectNat: {1: '216'},
      minute: '',
      second: '',
      fullscreenLoading: false,
      promiseTimer: '',
      frameDialog: false, // 弹框1
      frameHotelSoldDialog: false, // 弹框2 中文
      frameHotelSoldEnDialog: false, // 弹框2 英文
      frameHomeSoldDialog: false, // 弹框3
      frameRiseDialog: false, // 弹框4
      frameQuotationDialog: false, // 弹框5
      frameConinueOrderDialog: false, // 提醒下单弹框
      frameLastDialog: false, // 弹框6
      frameRemindDialog: false, // 弹框7
      frameToolongDialog: false,
      frameNetworkDialog: false,
      frameNoticeDialog: false,
      risePrice: 12.5,
      homeSurplus: 3,
      screenWidth: 0,
      currencyShow: false, // 币种是否显示
      loginStatus: false,
      firstName: '',
      lastName: '',
      userEmail: '',
      cancelData: 0,
      pageRefresh: 0,
      pageVerifyNum: 1,
      pageVerifyTimer: '',
      orderWritePageTime: 600,
      language: this.common.languageSet(this),
      orderno: '',
      guestClicksRetry: 0,
      dateNumComplexStr: '',
      roomNumComplexStr: '',
      ismobile: false,
      taxWidth: 327,
      taxDia: false,
      commissionDia: false,
      taxShowClose: false,
      special: '',
      elementWidth: document.documentElement.clientWidth,
      stepWidth: document.documentElement.clientWidth - 20,
      lineWidth: 98,
      lineOneLeft: 48,
      lineTwoLeft: 196,
      policyDialog: false,
      clauseDialog: false,
      source: 'roompai',
      inputCursor: true, // 登录数据
      mobileOverview: false, // 订房须知
      cancelDia: false,
      cancelShowClose: false,
      canceltextZh: '',
      canceltextEn: '',
      mandatoryFeeDetail: false,
      payment: {'total': {'status': '0'}},
      payment_card_show: false,
      paymentList: [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}],
      paymentMobileList: [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}],
      paymentOn: 'paypal',
      activeName: 'electronicPayment',
      paymentCardno: '0',
      paymentCardnoName: '',
      paymentCardnoEffectivedate: '',
      paymentCardnoValidCVV: '',
      showCardRemindTwo: false,
      securityCodeShow: false,
      showCardRemind: false,
      securityCodeShowTwo: false,
      cardNoError: 'validCardNumber',
      effectiveDateError: 'pleaseValidCardExpiry',
      securityCodeError: 'validCVV',
      cardNo: '',
      checked: false,
      checkIn: '',
      checkOut: '',
      discountPrice: 0,
      discountTotalPrice: 0,
      discountPayPrice: 0,
      couponId: 0,
      userCouponId: 0,
      ratio: 1,
      discountTotalPriceCNY: '',
      discountTotalPriceUSD: '',
      TransactionFeeshow: false,
      clausePolicyChecked: false, // 服务条款 和 隐私政策选择框
      jumpNextClickError: false, // 点击去支付弹框
      transactionFeeInfo: {},
      discountFeeInfo: {},
      frameChangeRoomDialog: false, // 价格不变，房型变更弹框
      frameChangePriceAndRoom: false, // 价格变更，房型变更
      sameRoomInfo: '',
      secSpecialHotelJudge: false,
      secSpecialHotelJudgeError: false,
      mobileLoginBindPopShow: false,
      mobileLoginBindPopAction: '',
      conver: ''
    }
  },
  beforeCreate () {
  },
  created () {
    // 判断是否登录
    if (localStorage.getItem('token')) {
      this.inputCursor = false
    }
    var params = this.$route.params
    var orderData = localStorage.getItem('orderData')
    if (JSON.stringify(params) === '{}' && orderData !== '{}') {
      params = JSON.parse(orderData)
    }

    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    } else {
      this.source = params.source
    }
    if (params.conver === 1 || params.conver === '1') {
      this.conver = params.conver
    }
    // 请求页面展示数据
    this.pageShow()
    var width = document.documentElement.clientWidth
    this.taxWidth = width - 40
    if (this.common.languageSet(this) === 'zh') {
      this.lineWidth = (width - 164) / 2
      this.lineOneLeft = 48
      this.lineTwoLeft = this.lineWidth + 96
    } else {
      this.lineWidth = (width - 260) / 2 + 32 // (屏幕宽度 - 左右两侧间距20 - 步骤宽度80*3)/2 = 剩余横线宽度 + 左右延申宽度*2：(整体宽度80-图标25)/2 = 两侧宽度-11.5*2
      this.lineOneLeft = 64 // (整体宽度80-图标25)/2 = 两侧宽度 + 25 = 左侧+图标宽度 + 缝隙11.5
      this.lineTwoLeft = this.lineOneLeft + this.lineWidth + 48 // 第一条线偏移度 + 第一条线长度 + 缝隙11.5:和中文一致*2 + 图标宽度25
    }
    if (location.host === 'www.roompai.com') {
      this.selectTel = '42'
      this.selectNat = {1: '42'}
    } else if (location.host === 'us.roompai.com') {
      this.selectTel = '216'
      this.selectNat = {1: '216'}
    } else {
      this.selectTel = '42'
      this.selectNat = {1: '42'}
    }
  },
  mounted () {
    var that = this
    // 错误提示
    this.userLastNameError = ''
    this.userNameError = ''
    this.emailError = ''

    if (this.remainTime > 0) {
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm()
    }

    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
    // 监听点击事件
    document.addEventListener('click', function (e) {
      var cardRemindShow = true
      for (var i = 0; i < e.target.classList.length; i++) {
        if (e.target.classList[i] === 'cardRemindShow') {
          cardRemindShow = false
        }
      }
      if (cardRemindShow) {
        that.showCardRemind = false
        that.showCardRemindTwo = false
      }
    })

    // 填入默认用户信息
    this.pageUserShow()
    //  默认电子支付方式
    // 保留支付方式
    var orderPaymentOn = sessionStorage.getItem('orderPaymentOn')
    this.paymentOn = 'paypal'
    if (orderPaymentOn !== null && orderPaymentOn !== undefined) {
      this.paymentOn = orderPaymentOn
    }
    if (location.host === 'us.roompai.com' || location.host === 'test.us.roompai.com' || location.host === 'localhost:8081') {
      if (this.common.isMobile()) {
        this.paymentMobileList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}]
      }
      if (this.source === 'sec') {
        this.paymentList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}]
        this.paymentMobileList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}]
      }
    } else {
      if (this.source === 'sec') {
        if (this.common.isMobile() === false) {
          this.paymentOn = 'wechat'
        }
        this.paymentList = [{'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}]
        // this.paymentMobileList = [{'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}]
      }
    }
    // 默认电子支付
    if (this.common.isMobile() === false) {
      this.changePayment(this.paymentOn)
    } else {
      this.changePaymentMobile(this.paymentOn)
    }
    setInterval(function () {
      if (that.payment.total.status === '1' && that.paymentCardno === '0') {
        for (let index in that.payment.list) {
          that.paymentCardno = that.payment.list[index].sign
          if (that.common.isMobile() === false) {
            that.changePaymentCardno(that.paymentCardno)
          } else {
            that.changePaymentCardnoMobile(that.paymentCardno)
          }
          return false
        }
      }
    }, 1000)
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1000) {
        this.ismobile = true
      } else {
        this.ismobile = false
      }
    },
    pageVerifyNum: function (news, olds) {
      console.log('news', news)
      if (news > 3) {
        this.frameConinueOrderDialog = false
        this.frameRemindDialog = true
        // 结束定时器
        clearInterval(this.pageVerifyTimer)
      } else {
        this.pageRefresh = 0
        this.frameRemindDialog = false
        this.frameConinueOrderDialog = true
        // this.orderVerify()
      }
    },
    language: function (newCur, oldCur) {
      this.pageShow()
    },
    $route: function (to, from) {
      console.log(to, from)
    }
  },
  beforeDestroy () {
  },
  methods: {
    mobileLoginBindPopCloseSetup: function (data) {
      if (data.bindRes) {
        console.log('绑定或手机号登录成功，自动提交订单')
        this.JumpNext()
      }
      this.mobileLoginBindPopShow = false
    },
    getSite () {
      let site = ''
      if (location.host === 'www.roompai.com') {
        site = 'www'
      } else if (location.host === 'us.roompai.com' || location.host === 'test.us.roompai.com') {
        site = 'us'
      }
      return site
    },
    hotelLanguage (language) {
      this.language = language
    },
    getfirstName (firstName) {
      this.firstName = firstName
    },
    checkSpecial () {
      this.special = this.special.replace(/[\u4e00-\u9fa5/]|[^a-zA-Z0-9\u4E00-\u9FA5\s+,.!-?:;()/]/g, '')
    },
    pageUserShow: function () {
      var orderUserDataJson = sessionStorage.getItem('orderUserData')
      var orderUserData = JSON.parse(orderUserDataJson)
      if (orderUserData === null) {
        this.$refs['userlastname1'].value = this.lastName
        this.$refs['username1'].value = this.firstName
        this.$refs['emails'].value = this.userEmail
        return ''
      }

      if (orderUserData.roomHost !== undefined && orderUserData.roomHost.userlastname !== '') {
        this.$refs['userlastname1'].value = orderUserData.roomHost.userlastname
      } else {
        this.$refs['userlastname1'].value = this.lastName
      }
      if (orderUserData.roomHost.username !== '') {
        this.$refs['username1'].value = orderUserData.roomHost.username
      } else {
        this.$refs['username1'].value = this.firstName
      }
      if (orderUserData.roomHost.emails !== '') {
        this.$refs['emails'].value = orderUserData.roomHost.emails
      } else {
        this.$refs['emails'].value = this.userEmail
      }

      if (orderUserData.roomHost.areaCode !== '') {
        this.selectTel = orderUserData.roomHost.areaCode
      }
      if (orderUserData.roomHost.tel !== '') {
        this.$refs['tel1'].value = orderUserData.roomHost.tel
      }
      if (orderUserData.roomHost.specialRequirements !== '') {
        this.special = orderUserData.roomHost.specialRequirements
      }
      if (orderUserData.roomHost.nationality !== '') {
        this.selectNat[1] = orderUserData.roomHost.nationality
      }
      if (orderUserData.roomOther !== '[]') {
        for (var item in orderUserData.roomOther) {
          var key = parseInt(item)
          var index = key + 2

          this.$refs['userlastname' + index][0].value = orderUserData.roomOther[key].userlastname
          this.$refs['username' + index][0].value = orderUserData.roomOther[key].username
          this.selectNat[index] = orderUserData.roomOther[key].nationality
        }
      }
    },
    // 请求页面展示数据
    pageShow: function () {
      var that = this

      let locationHref = window.document.location.href
      var params = this.$route.params
      console.log(params)
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }
      console.log(params)

      this.hotelid = params.hotelid
      this.guestRoomNum = params.room

      if (params.childNums === undefined) {
        params.childNums = []
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      this.checkIn = params.checkin
      this.checkOut = params.checkout
      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      var sessionid = this.common.sessionidGet(this)
      var initUrl = sessionStorage.getItem('roompaiAccessLink')
      if (initUrl === undefined || initUrl === null) {
        initUrl = ''
      }
      // this.source = params.source
      // 订单信息填写数据
      var orderDataJson = {
        'token': token,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'product': params.product,
        'time': time,
        'source': this.source,
        'currency': currency,
        'language': this.language,
        'sessionid': sessionid,
        'initUrl': initUrl,
        'operation': 'writeOrderShow'
      }
      var orderDataShow = this.common.encryptionData(orderDataJson, this)
      writeOrderShow(orderDataShow).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '165') {
          // 进入订单填写页面超过规定时间
          this.frameToolongDialog = true
        } else {
          if (res.data.orderData.createtime !== 0) {
            this.orderWritePageTime = res.data.orderData.orderWritePageTime

            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.orderData.createtime)
            if (dateTime <= this.orderWritePageTime) {
              this.remainTime = this.orderWritePageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
          }

          // 信息
          this.hotel = res.data.hotel
          this.telOptions = res.data.countryCode
          this.nationalityOptions = res.data.nationality
          this.cancelData = res.data.orderData.cancelData.en
          this.loginStatus = res.data.orderData.loginStatus
          this.firstName = res.data.orderData.firstname
          this.lastName = res.data.orderData.lastname
          this.userEmail = res.data.orderData.useremail
          this.guestRoomNum = res.data.orderData.selectRoom
          this.orderData = res.data.orderData
          this.transactionFeeInfo = this.orderData.transactionFeeInfo
          this.discountFeeInfo = this.orderData.discountTFeeInfo
          this.canceltextZh = this.orderData.canceltext.zh
          this.canceltextEn = this.orderData.canceltext.en
          this.secSpecialHotelJudge = this.orderData.secSpecialHotelJudge
          if (this.orderData.discount !== '') {
            this.discountPrice = this.orderData.discount
            this.discountTotalPrice = this.orderData.discountTotalPrice
            this.discountPayPrice = this.orderData.discountPayPrice
            this.couponId = this.orderData.coupon_id
            this.userCouponId = this.orderData.user_coupon_id
            this.ratio = this.orderData.ratio
            this.discountTotalPriceCNY = this.orderData.discountTotalPriceCNY
            this.discountTotalPriceUSD = this.orderData.discountTotalPriceUSD
          }
          if (['paypal', 'pingpong'].includes(this.paymentOn) && this.transactionFeeInfo !== '' && this.source === 'sec') {
            this.TransactionFeeshow = true
          } else {
            this.TransactionFeeshow = false
          }

          // 处理支付方式逻辑.
          if (this.orderData.paymentConfig !== null && this.orderData.paymentConfig !== undefined) {
            // web.
            this.paymentList = this.orderData.paymentConfig.paymentList.list
            // mobile
            this.paymentMobileList = this.orderData.paymentConfig.paymentMobileList.list
            // default.
            let orderPaymentOn = sessionStorage.getItem('orderPaymentOn')
            if (this.common.isMobile() === false) {
              if (this.paymentList.includes(orderPaymentOn)) {
                this.paymentOn = orderPaymentOn
              } else {
                this.paymentOn = this.orderData.paymentConfig.paymentList.default
              }
              this.changePayment(this.paymentOn)
            } else {
              if (this.paymentMobileList.includes(orderPaymentOn)) {
                this.paymentOn = orderPaymentOn
              } else {
                this.paymentOn = this.orderData.paymentConfig.paymentMobileList.default
              }
              this.changePaymentMobile(this.paymentOn)
            }
          }

          that.pageUserShow()

          // 判断夜是否大于1
          if (this.language === 'en' && res.data.orderData.night.en > 1) {
            this.dateNumComplexStr = 's'
          } else {
            this.dateNumComplexStr = ''
          }
          // 判断房间是否大于1
          if (this.language === 'en' && res.data.orderData.roomNum.en > 1) {
            this.roomNumComplexStr = 's'
          } else {
            this.roomNumComplexStr = ''
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(orderDataShow, res, requestTime, responseTime)
        })
      })
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      if (['hotelname', 'hoteladdress'].includes(type)) {
        var typeLan = type + '_' + getLanguage
        return data[typeLan]
      } else if (['roomName', 'checkin', 'checkout', 'night', 'roomNum', 'person', 'child', 'bedType', 'breakfast', 'cancel', 'cancelData'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.zh
        } else {
          return data.en
        }
      } else if (['userLastNameError', 'userNameError', 'emailError', 'telError', 'emailConfirmError', 'cardNoError', 'effectiveDateError', 'securityCodeError', 'emailError', 'telError', 'emailConfirmError', 'paymentLabelShow'].includes(type)) {
        return this.$t(data)
      } else if (['paymentLabel'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.label_zh
        } else {
          return data.label_en
        }
      } else if (['buttonMeansYouAgree', 'agreeToRoompai'].includes(type)) {
        return this.$t(type)
      }
    },
    blurs (refInfo) {
      var refName = this.$refs[refInfo].value
      if (refName === '' || refName === null) {
        if (refInfo === 'userlastname1') {
          this.userLastNameError = 'pleaseLastName'
        }
        if (refInfo === 'username1') {
          this.userNameError = 'pleaseFirstName'
        }
        if (refInfo === 'emails') {
          this.emailError = 'pleaseEnterYourEmailOrYouMightMissBooking'
        }
        this.$set(this.someArray, refInfo, true)
      } else {
        var pattern = ''
        if (refInfo === 'userlastname1') {
          this.userLastNameError = ''
        }
        if (refInfo === 'username1') {
          this.userNameError = ''
        }

        if (refInfo === 'emails') {
          // pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+.([a-zA-Z]{2,4})$/
          pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (!pattern.test(refName)) {
            this.emailError = 'pleaseValidEmailReservationConfirmationEmail'
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        } else if (refInfo === 'tel1') {
          pattern = /^[0-9]*$/
          if (this.selectTel === '42') {
            pattern = /^1[0-9]{10}$/
          }
          if (!pattern.test(refName)) {
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        } else {
          pattern = /^[a-zA-Z\s]+$/
          // 不支持单引号
          // var pattern1 = new RegExp("[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}':;'/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]")
          // 支持单引号
          // var pattern1 = new RegExp('[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}:;/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“。，、？%+_]')
          if (!pattern.test(refName)) {
            if (refInfo === 'userlastname1') {
              this.userLastNameError = 'pleaseTextEnglish'
            }
            if (refInfo === 'username1') {
              this.userNameError = 'pleaseTextEnglish'
            }
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        }
      }

      this.frameRiseDialog = false
      this.frameChangeRoomDialog = false
      this.frameChangePriceAndRoomDialog = false
    },
    blursMore (refInfo, refInfoTwo) {
      // var pattern = new RegExp(/[\u4e00-\u9fa5/\s+/]|[`~!@#$%^&*() \\+ =<>?"{}|, \\/ ;' \\ [ \] ·~！@#￥%……&*（）—— \\+ ={}|《》？：“”【】、；‘’，。、_.-:]/g)
      var refName = this.$refs[refInfo][0].value
      if (refName === '' || refName === null) {
        this.$set(this.someArray, refInfo, true)
        this.$set(this.someArray, refInfoTwo, false)
      } else {
        // var pattern = new RegExp('[A-Za-z]+')
        // var pattern1 = new RegExp("[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}':;'/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]")
        // var pattern1 = new RegExp('[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}:;/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“。，、？%+_]')
        var pattern = /^[a-zA-Z\s]+$/
        if (!pattern.test(refName)) {
          this.$set(this.someArray, refInfo, false)
          this.$set(this.someArray, refInfoTwo, true)
        } else {
          this.$set(this.someArray, refInfo, false)
          this.$set(this.someArray, refInfoTwo, false)
        }
      }
    },
    formatCardNumber (e) {
      const input = e.target
      const cursorIndex = input.selectionStart
      const lineNumOfCursorLeft = (e.target.value.slice(0, cursorIndex).match(/\s/g) || []).length
      const noLine = e.target.value.replace(/\s/g, '')
      const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '')
      const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length
      const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft
      this.$nextTick(() => {
        this.cardNo = newCardNum
        this.$nextTick(() => {
          input.selectionStart = newCursorIndex
          input.selectionEnd = newCursorIndex
        })
      })
    },
    blursCode (refInfo) {
      var refName = this.$refs[refInfo].value
      if (refName === '' || refName === null) {
        this.securityCodeShow = true
      } else {
        if (refName.length !== 3) {
          this.securityCodeShow = true
        } else {
          this.securityCodeShow = false
        }
      }
    },
    getSomeThing (index) { // 返回数组元素
      return this.someArray[index]
    },
    telChange () {
      this.selectNat[1] = this.selectTel
    },
    JumpNext () {
      let locationHref = window.document.location.href
      // 保留支付方式
      sessionStorage.setItem('orderPaymentOn', this.paymentOn)

      // 服务条款 和 隐私政策选择框
      if (this.clausePolicyChecked === false) {
        this.jumpNextClickError = true
        return false
      }

      // sec 客人没有填特殊 信息
      if (this.secSpecialHotelJudge === true && this.$refs['specialRequirements'].value === '') {
        document.querySelector('.el-textarea__inner').style.border = 'solid 1px red'
        this.secSpecialHotelJudgeError = true
        return false
      }
      document.querySelector('.el-textarea__inner').style.border = 'solid 1px #C0C4CC'
      this.secSpecialHotelJudgeError = false

      // 第一位客户
      this.$options.methods.blurs.bind(this)('userlastname1')
      let userlastname1R = this.$options.methods.getSomeThing.bind(this)('userlastname1')
      if (userlastname1R === true) {
        this.$refs['userlastname1'].focus()
        return false
      }
      this.$options.methods.blurs.bind(this)('username1')
      let username1R = this.$options.methods.getSomeThing.bind(this)('username1')
      if (username1R === true) {
        this.$refs['username1'].focus()
        return false
      }
      this.$options.methods.blurs.bind(this)('emails')
      let emailsR = this.$options.methods.getSomeThing.bind(this)('emails')
      if (emailsR === true) {
        this.$refs['emails'].focus()
        return false
      }
      this.$options.methods.blurs.bind(this)('tel1')
      let tel1R = this.$options.methods.getSomeThing.bind(this)('tel1')
      if (tel1R === true) {
        this.$refs['tel1'].focus()
        return false
      }
      // 其他客户
      var userOtherInfo = []
      for (let index = 2; index <= this.guestRoomNum; index++) {
        // let userlastnames = this.$refs['userlastname' + index][0].value
        this.$options.methods.blursMore.bind(this)('userlastname' + index, 'userlastnametwo' + index)
        let userlastnameR1 = this.$options.methods.getSomeThing.bind(this)('userlastname' + index)
        let userlastnameR2 = this.$options.methods.getSomeThing.bind(this)('userlastnametwo' + index)
        if (userlastnameR1 === true || userlastnameR2 === true) {
          this.$refs['userlastname' + index][0].focus()
          return false
        }
        this.$options.methods.blursMore.bind(this)('username' + index, 'usernametwo' + index)
        let usernameR1 = this.$options.methods.getSomeThing.bind(this)('username' + index)
        let usernameR2 = this.$options.methods.getSomeThing.bind(this)('usernametwo' + index)
        if (usernameR1 === true || usernameR2 === true) {
          this.$refs['username' + index][0].focus()
          return false
        }
        var userlastnameR = this.$refs['userlastname' + index][0].value
        var usernameR = this.$refs['username' + index][0].value
        // var nationalityR = this.$refs['nationality' + index][0].value
        var nationalityR = this.selectNat[index]
        var userOtherR = {'userlastname': userlastnameR, 'username': usernameR, 'nationality': nationalityR}
        userOtherInfo.push(userOtherR)
      }

      this.fullscreenLoading = true

      // 获取用户填写信息
      var userlastname1 = this.$refs['userlastname1'].value
      var username1 = this.$refs['username1'].value
      var emails = this.$refs['emails'].value
      var tel1 = this.$refs['tel1'].value
      var specialRequirements = this.$refs['specialRequirements'].value

      // 用户订单数据 存入 localStorage
      var orderUserData = {
        'roomHost': {'userlastname': userlastname1, 'username': username1, 'emails': emails, 'tel': tel1, 'specialRequirements': specialRequirements, 'areaCode': this.selectTel, 'nationality': this.selectNat[1]},
        'roomOther': userOtherInfo
      }
      sessionStorage.setItem('orderUserData', JSON.stringify(orderUserData))

      // 订单信息
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var currency = this.common.currencySet(this)
      var language = this.common.languageSet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var platfromParam = sessionStorage.getItem('platfromParam')
      if (platfromParam === null || platfromParam === 'null' || platfromParam === undefined) {
        platfromParam = ''
      }

      var localUrl = params.hotelUrl !== undefined ? params.hotelUrl : ''

      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }
      var initUrl = sessionStorage.getItem('roompaiAccessLink')
      if (initUrl === undefined || initUrl === null) {
        initUrl = ''
      }

      // 订单信息填写数据
      var orderDataJson = {
        'token': token,
        'userlastname': userlastname1,
        'username': username1,
        'emails': emails,
        'tel': tel1,
        'areaCode': this.selectTel,
        'nationality': this.selectNat[1],
        'userOtherInfo': JSON.stringify(userOtherInfo),
        'specialRequirements': specialRequirements,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums !== undefined ? params.childNums : '',
        'product': params.product,
        'time': time,
        'source': this.source,
        'currency': currency,
        'language': language,
        'sessionid': sessionid,
        'guestClicksRetry': this.guestClicksRetry,
        'platfromParamLs': platfromParam,
        'operation': 'orderFillCosInfo',
        'hotelUrl': localUrl,
        'roompaiToken': roompaiToken,
        'page_site': this.getSite(),
        'userCouponId': this.userCouponId,
        'ratio': this.ratio,
        'paymentOn': this.paymentOn,
        'bookingOrderUrl': locationHref,
        'initUrl': initUrl,
        'conver': this.conver
      }
      var orderFillInfo = this.common.encryptionData(orderDataJson, this)
      // 点击booking记录埋点
      // this.clickPageAction('nextFinalstep', '', orderDataJson)
      orderFillCosInfo(orderFillInfo).then(res => {
        // 点击完成 埋点记录
        this.clickPageAction('nextFinalstep', '', orderDataJson, orderFillInfo, res)

        this.fullscreenLoading = false
        if (res.flag === '001') {
          // this.mobileLoginBindPopAction = 'login'
          // this.mobileLoginBindPopShow = true
          // 修改一下，先不用手机号登录，改为跳转邮箱登录.
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '155') {
          // 无母房型有报价
          if (this.common.languageSet(this) === 'zh') {
            this.frameHotelSoldDialog = true
          } else {
            this.frameHotelSoldEnDialog = true
          }
          this.orderno = res.data.orderno
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.frameHomeSoldDialog = true
          this.orderno = res.data.orderno
        } else if (res.flag === '153') {
          // 涨价
          this.frameRiseDialog = true
          this.risePrice = res.data.priceRise
          this.orderno = res.data.orderno
        } else if (res.flag === '163') {
          // 变更房型
          this.frameChangeRoomDialog = true
          this.sameRoomInfo = res.data.sameRoomInfo
          this.orderno = res.data.orderno
        } else if (res.flag === '173') {
          // 涨价，且变更房型
          this.frameChangePriceAndRoomDialog = true
          this.sameRoomInfo = res.data.sameRoomInfo
          this.risePrice = res.data.priceRise
          this.orderno = res.data.orderno
        } else if (['157', '500', '177'].includes(res.flag)) {
          this.guestClicksRetry = res.data.guestClicksRetry
          if (res.data.guestClicksRetry) {
            // 网络中断，重试
            this.frameNoticeDialog = true
          } else {
            // 网络错误，请重新预定
            this.frameNetworkDialog = true
          }
        } else if (['200'].includes(res.flag)) {
          this.orderno = res.data.orderno
          this.jumpPayOrderPage(1)
        } else if (['511'].includes(res.flag)) {
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'intercepting', params: {'querys': newQuerys}})
        } else if (res.flag === '102') { // 风控高风险弹窗.
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
        } else if (res.flag === '103') { // 风控中风险绑定手机号.
          sessionStorage.setItem('BindMobileWebsiteAddress', locationHref)
          this.$message({
            type: 'error',
            message: this.$t(res.msg)
          })
          setTimeout(() => {
            let newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user'}, 'obj')
            if (this.conver === 1 || this.conver === '1') {
              newQuerys = this.common.linkEncode({'source': this.source, 'bindMobile': '1', 'type': 'user', 'conver': this.conver}, 'obj')
            }
            this.$router.push({name: 'intercepting', params: {'querys': newQuerys}})
          }, 1000)
        } else if (res.flag === '513') { // 手机号格式错误.
          this.$refs['tel1'].focus()
          this.$set(this.someArray, 'tel1', true)
        } else if (res.flag === '514') {
          this.mobileLoginBindPopAction = 'bind'
          this.mobileLoginBindPopShow = true
          console.log(this.mobileLoginBindPopAction)
        }
      })
    },
    jumpPayOrderPage: function () {
      // 订单信息
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }
      var orderInfoData = {
        'hotelid': params.hotelid,
        'product': params.product,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'source': this.source,
        'orderno': this.orderno,
        'conver': this.conver
      }
      localStorage.setItem('orderData', JSON.stringify(orderInfoData))
      var autoPay = 1
      if (this.paymentOn === 'pingpong' || this.paymentOn === 'credit-card') {
        autoPay = 2
      }
      var ordernInfo = {
        'orderno': this.orderno,
        'source': this.source,
        'autoPay': autoPay,
        'paymentOn': this.paymentOn,
        'conver': this.conver
      }
      var newQuerys = this.common.linkEncode(ordernInfo, 'obj')
      orderInfoData['querys'] = newQuerys
      this.$router.push({name: 'WritePay', params: orderInfoData})
    },
    orderVerify: function () {
      // 请求验价数据
      var language = this.common.languageSet(this)
      let locationHref = window.document.location.href
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      var sessionid = this.common.sessionidGet(this)

      var localUrl = params.hotelUrl !== undefined ? params.hotelUrl : ''
      var roompaiToken = '0'
      if (localStorage.getItem('roompaiStorageToken')) {
        roompaiToken = localStorage.getItem('roompaiStorageToken')
      }

      var verifyJson = {
        'type': 3,
        'type_id': params.hotelid,
        'hotelid': params.hotelid,
        'product': params.product,
        'token': token,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums !== undefined ? params.childNums : '',
        'checkin': params.checkin,
        'checkout': params.checkout,
        'currency': currency,
        'source': this.source,
        'pageRefresh': this.pageRefresh,
        'sessionid': sessionid,
        'hotelUrl': localUrl,
        'roompaiToken': roompaiToken,
        'operation': 'orderBookVerify',
        'time': time
      }
      var verifyData = this.common.encryptionData(verifyJson, this)
      orderBookVerify(verifyData).then(res => {
        this.frameConinueOrderDialog = false
        if (res.flag === '001') {
          // 未登录
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (['155', '150'].includes(res.flag)) {
          // 无母房型有报价
          if (language === 'zh') {
            this.frameHotelSoldDialog = true
          } else {
            this.frameHotelSoldEnDialog = true
          }
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.frameHomeSoldDialog = true
        } else if (['153', '163', '173', '200'].includes(res.flag)) {
          if (this.pageRefresh === 0 && res.data.time !== 0) {
            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.time)
            if (dateTime <= this.orderWritePageTime) {
              this.remainTime = this.orderWritePageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
            this.countDowm()
          }

          if (res.flag === '153') {
            // 涨价
            this.frameRiseDialog = true
            this.risePrice = res.data.priceRise
          } else if (res.flag === '163') {
            // 变更房型
            this.frameChangeRoomDialog = true
            this.sameRoomInfo = res.data.sameRoomInfo
          } else if (res.flag === '173') {
            // 涨价，且变更房型
            this.frameChangePriceAndRoomDialog = true
            this.sameRoomInfo = res.data.sameRoomInfo
            this.risePrice = res.data.priceRise
          } else if (res.flag === '200') {
            // 成功
            // location.reload()
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(verifyData, res, requestTime, responseTime, 'confirmPrice')
        })
      })
    },
    continueBookingFun: function (val) {
      // 继续预订 记录埋点
      this.clickPageAction('continue_order', '', {})

      this.frameRemindDialog = false
      this.pageRefresh = 0
      this.frameConinueOrderDialog = true
      this.orderVerify()
    },
    frameRiseBookingBackFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
    },
    frameRiseBookingFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
      this.jumpPayOrderPage()
    },
    frameChangeRoomBookingBackFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangeRoomBookingFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
      this.jumpPayOrderPage()
    },
    frameChangePriceAndRoomBookingBackFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangePriceAndRoomBookingFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
      this.jumpPayOrderPage()
    },
    // 网络中断请重试
    frameNoticeFun: function (val) {
      this.JumpNext()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    countDowm () {
      var self = this
      clearInterval(this.promiseTimer)
      this.promiseTimer = setInterval(function () {
        if (self.minute !== 0 && self.second === 0) {
          self.second = 59
          self.minute -= 1
        } else if (self.minute === 0 && self.second === 0) {
          self.second = 0
          self.$emit('countDowmEnd', true)
          clearInterval(self.promiseTimer)
          self.pageVerifyNum++
          // self.frameRiseDialog = true
        } else {
          self.second -= 1
        }
      }, 1000)
    },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    },
    refresh () {
      location.reload()
      this.frameDialog = false
      this.frameRiseDialog = false
    },
    reserve () {
      this.frameRiseDialog = false
      this.frameDialog = true
    },
    login () {
      // 其他客户
      var userOtherInfo = []
      for (let index = 2; index <= this.guestRoomNum; index++) {
        var userlastnameR = this.$refs['userlastname' + index][0].value
        var usernameR = this.$refs['username' + index][0].value
        var nationalityR = this.selectNat[index]
        var userOtherR = {'userlastname': userlastnameR, 'username': usernameR, 'nationality': nationalityR}
        userOtherInfo.push(userOtherR)
      }

      // 获取用户填写信息
      var userlastname1 = this.$refs['userlastname1'].value
      var username1 = this.$refs['username1'].value
      var emails = this.$refs['emails'].value
      var tel1 = this.$refs['tel1'].value
      var specialRequirements = this.$refs['specialRequirements'].value

      // 用户订单数据 存入 localStorage
      var orderUserData = {
        'roomHost': {'userlastname': userlastname1, 'username': username1, 'emails': emails, 'tel': tel1, 'specialRequirements': specialRequirements, 'areaCode': this.selectTel, 'nationality': this.selectNat[1]},
        'roomOther': userOtherInfo
      }
      sessionStorage.setItem('orderUserData', JSON.stringify(orderUserData))

      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)

      // 登录记录埋点
      this.clickPageAction('sign_in', '', {})

      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'login', params: {'querys': newQuerys}})
    },
    loginOut: function () {
      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')

      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {'token': token, 'operation': 'loginOut', 'time': time}
      var data = this.common.encryptionData(dataJson, this)

      // 退款记录埋点
      this.clickPageAction('sign_out', '', data)

      this.loginStatus = false
      localStorage.removeItem('token')
      localStorage.removeItem('sessionid')
      localStorage.removeItem('LoginWebsiteAddress')

      if (token !== undefined && token !== '' && token !== null) {
        signIn(data).then(res => {
          this.$nextTick(() => {
            // 埋点日志记录
            let logData = {
              'name': this.$route.name,
              'path': this.$route.path
            }
            this.clickPageAction('loginOut', '', logData, data, res)
          })
          location.reload()
        })
      }
    },
    closeCardRemind () {
      this.showCardRemind = false
      this.showCardRemindTwo = false
    },
    getPolicyDia (val) {
      this.policyDialog = val
    },
    getClauseDia (val) {
      this.clauseDialog = val
    },
    changePayment (scope) {
      let brand = scope
      for (let index in this.paymentList) {
        let aa = this.paymentList[index]
        let value = aa.value
        if (brand === value) {
          this.$refs.paymentSelect.$el.children[0].children[0].setAttribute('style', 'background:url(' + aa.src + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')
        }
      }
      if (['paypal', 'pingpong'].includes(this.paymentOn) && this.transactionFeeInfo !== '' && this.source === 'sec') {
        this.TransactionFeeshow = true
      } else {
        this.TransactionFeeshow = false
      }
    },
    changePaymentMobile (scope) {
      let brand = scope
      for (let index in this.paymentMobileList) {
        let aa = this.paymentMobileList[index]
        let value = aa.value
        if (brand === value) {
          this.activeName = value
          this.$refs.paymentSelectMobile.$el.children[0].children[0].setAttribute('style', 'background:url(' + aa.src + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')
        }
      }
      if (['paypal', 'pingpong'].includes(this.paymentOn) && this.transactionFeeInfo !== '' && this.source === 'sec') {
        this.TransactionFeeshow = true
      } else {
        this.TransactionFeeshow = false
      }
    },
    changePaymentCardno (cardno) {
      for (let index in this.payment.list) {
        let aa = this.payment.list[index]
        let sign = aa.sign
        if (cardno === sign) {
          this.paymentCardnoName = aa.cardholder_name
          this.paymentCardnoEffectivedate = aa.effectivedate
          this.paymentCardnoValidCVV = aa.effectivedate
        }
      }
    },
    changePaymentCardnoMobile (cardno) {
      for (let index in this.payment.list) {
        let aa = this.payment.list[index]
        let sign = aa.sign
        if (cardno === sign) {
          var urlsrc = ''
          if (aa.type === 'visa') {
            urlsrc = 'https://res.roompai.com/static/img/order/visa.png'
          }
          if (aa.type === 'master') {
            urlsrc = 'https://res.roompai.com/static/img/order/mastercard.png'
          }
          this.$refs.paymentCardnoMobile.$el.children[0].children[0].setAttribute('style', 'background:url(' + urlsrc + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')

          this.paymentCardnoName = aa.cardholder_name
          this.paymentCardnoEffectivedate = aa.effectivedate
          this.paymentCardnoValidCVV = aa.effectivedate
        }

        this.showCardRemind = false
        this.showCardRemindTwo = false
      }
    },
    showCardRemindInfo () {
      this.showCardRemind = true
    },
    showCardRemindInfoTwo () {
      this.showCardRemindTwo = true
    },
    linkClick (type, click = '1') {
      // 点击 记录埋点
      if (type === 'clause') {
        if (click === '2') {
          this.clauseDialog = true
        }
        this.clickPageAction('writeOrder_terms_use', '', {})
      } else if (type === 'policy') {
        if (click === '2') {
          this.policyDialog = true
        }
        this.clickPageAction('writeOrder_privacy_policy', '', {})
      }
    },
    getCouponInfo (val) {
      this.userCouponId = val['userCouponId']
      this.couponId = val['couponId']
      this.discountTotalPriceCNY = ''
      this.discountTotalPriceUSD = ''
    },
    clausePolicyCheckedChange: function () {
      this.jumpNextClickError = false
    }
  },
  computed: {
    minuteString () {
      return this.formatNum(this.minute)
    },
    secondString () {
      return this.formatNum(this.second)
    }
  }
}
</script>

<style scoped>
.main{background-color: #fff;height:auto; margin:90px auto auto;width:1100px;}
/* 步骤条 */
.stepinfo{text-align: center;margin: 30px auto; width: 100%;}
.el-step.is-center .el-step__line{left:20%; right:2%;background-color:#4F4C4C; height: 1px;top:14.5px;}
.el-step.is-center .step-two-zh{margin-right: 0px;left: 20%;right: 2%;}
.el-step.is-center .step-two-en{margin-right: 0px;left: 27%;right: 2%;}
.el-step.is-center .step-one-zh{margin-right: 0px;right: 2%;left: 20%;}
.el-step.is-center .step-one-en{margin-right: 0px;right: 2%;left: 27%;}
.step-img{width: 30px;height: 30px;vertical-align:middle;}
.step-text{color:#4F4C4C;font-size: 14px; font-weight: 600;}
.order-step{width: 497px; margin-right: 0px;}
.div-hidden{display:none}

/* 左侧开始 */
.msg-left{ width:736px;display:inline-block;float:left; margin-right:12px;}
/* 登录/注册账号入口 */
.msg-blue{height:50px;font-size: 14px;background-color: rgba(233, 238, 249, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); margin-bottom: 12px;}
.blue-back{border:none; width:50px; height:50px; background-color:#5392F9;vertical-align:middle;}
.blue-logo, .orange-logo{width: 30px;height: 30px; float:left; margin: 10px;}
.msg-blue div, .msg-orange div{display:inline-block; float: left;}
.blue-text{line-height:50px; height:50px;}
.blue-maintext{color:#5392F9; font-weight:650;padding: 0px 10px;cursor: pointer;}
.email-maintext{color:#303133; font-weight: 650;padding: 0px 10px;}
.msg-pink{height:50px; color:#F56C6C;font-size: 14px;background-color: rgba(254, 240, 240, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
.pink-back{border:none; width:50px; height:50px; background-color:rgba(245, 108, 108, 1);vertical-align:middle;}
.pink-logo, .green-logo{width: 30px;height: 30px; float:left; margin: 10px;}
.msg-pink div, .msg-green div{display:inline-block; float: left;}
.pink-text{line-height:50px; height:50px; padding-left:10px;}
.pink-maintext{font-weight:650; color:#F56C6C;}

.msg-green{height:17px;font-size: 14px; border: none;margin:0px 0px 10px;line-height: 17px;}
.green-back{border:none; width:17px; height:17px; vertical-align:middle;}
.green-text-zh,.green-text-en{height:20px; color:#67C23A;}
.green-logo{width: 17px;height: 17px; float:left;margin:0}
/* 时间倒计时 */
.msg-orange{height:50px;font-size: 14px; color:#E6A23C; background-color: rgba(253, 246, 236, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
.msg-bule-show{margin-top:10px;}
.orange-back{border:none; width:50px; height:50px; background-color:rgba(230, 162, 60, 1);vertical-align:middle;}
.orange-text{line-height:50px; height:50px; padding-left:10px;}
.orange-maintext{font-weight:650;}
/* 住客资料 */
.input-bor /deep/ .el-select .el-input.is-focus .el-input__inner,.input-bor /deep/ .el-select .el-input__inner:focus{border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.msg-guest{border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-top:10px;padding-bottom:20px;}
.msg-lastname,.msg-username{width:49%;display:inline-block;}
.msg-name{text-align: right;vertical-align: middle;float: left;font-size: 14px;color: #606266;line-height: 40px; padding: 0 12px 0 0;-webkit-box-sizing: border-box;box-sizing: border-box;}
.msg-guest{ font-size:13px;}
.msg-guest input:hover{ border-color:rgb(79, 76, 76, 1);}
.msg-guest input:focus{ border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
.msg-guest .el-form-item__error{color:#E12D2D; font-size:12px;}
.el-select-dropdown {display:block;}
.msg-empty{ border-color: #E12D2D;}
.el-form-item__error{color:#E12D2D;}
.remind-font{font-size:14px;}
.remind-text{color:#5392F9; font-weight:650;text-decoration:none;}
.tonext{padding: 2px 20px; text-align:right;}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{color:#5392F9;}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{ background-color: #5392F9; border-color: #5392F9;}
/* 特殊要求 */
.specialText{height: 80px; /* line-height: 80px; */ font-size: 14px;padding: 0px;border:none;}
.specialText /deep/ textarea{height:100%;resize:none}
/deep/ .el-textarea .el-input__count{background: rgb(255, 255, 255, 0.7)}
.surplus-room{font-size:12px; color:#E12D2D;}
/* 搜索 */
.order_button{width:30%;height:51px;font-size:16px; font-weight:650; background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
.order_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
.order_button:focus{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
/* 右侧部分 */
.msg-right-all{width:352px; float: right;}
.msg-right{width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;}
/* 评分 */
.score-bar{width: 100%;-webkit-box-sizing: border-box;box-sizing: border-box;}
.scoreNo{height: 6px;border-radius: 0px 4px 4px 0px;background-color: rgba(79, 76, 76, 1);overflow: hidden;position: relative;vertical-align: middle;}
.scoreYes{height: 100%;border-radius: 0px;text-align: right;line-height: 1;white-space: nowrap;-webkit-transition: width .6s ease;transition: width .6s ease;background-color:rgba(252, 210, 5, 1);}
/* 预订信息 */
.advanceText{font-size:18px; font-weight:650; border-bottom: 1px solid rgba(221, 223, 226, 1);height: 54px; line-height: 54px; padding:0px 4.5%;}
.advanceInfo{ margin-top:13px;color:#333333;padding: 0px 4.5%;}
.titletd{ width:35%; font-size:14px; font-weight:650; display:inline-block;vertical-align: top;color:#333333;}
.infotd{ width: 60%;display: inline-block;color:#333333;}
.advanceInfo td{ padding-bottom:12px;}
.greenText{color:#2F7000;}
/deep/ .el-checkbox__label{font-size:12px;}

.redText{color:#E12D2D;}
/* 价格详情 */
.msg-price{width:28%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;}
.priceText{font-size:18px; font-weight:650;height: 54px;padding: 0px 4.5%; line-height: 54px;}
.priceInfo{background-color:rgba(221, 223, 226, 0.2980392156862745); height:auto; font-size:14px;color:#333333;}
.avgprice{display:block;color:#616161;font-size:12px;}
/* .priceInfo div{ margin-bottom:20px;} */
.jianye div{margin-bottom: 20px;}
.jianye span{margin-top:5px;}
.popverText{ font-size:12px;width:20%;}
/* 新步骤条 */
.order-step-new-zh{ display:inline-block; width: 100px;}
.order-step-new-en{display:inline-block; width: 130px; text-align:center;}
.step-line-one-zh{width:386px; left: 106px;position:relative; top: 12.5px;}
.step-line-two-zh{width: 386px;left: 608px;position:relative; top:12.5px;}
.step-line-one-en{width:342px; left: 136px;position:relative; top: 12.5px;}
.step-line-two-en{width: 349px;left: 623px;position:relative; top:12.5px;}

/* 住房须知 */
.hotelFeesText /deep/ p{margin-block-start: 5px;margin-block-end: 5px;}
.hotelFeesText /deep/ ul{margin-left:20px;margin-bottom: 10px;}

/* 住房须知 */
.hotel-detail-info-mobile{margin-top: 10px;}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top{width:100%;min-height: 50px;border-bottom: 1px solid rgba(221, 223, 226, 1);}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top-active{box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);border-radius: 5px;}
.hotel-detail-info-mobile .hotel-data-info /deep/ .el-card__body{width:100%;height:100%;padding: unset;}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-text{margin: 10px;width: 50%;min-height: 30px;line-height: 30px;float: left;font-size: 14px;}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-img{margin: 10px 20px;width: 10%;min-height: 30px;line-height: 30px;float: right;text-align:right;}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-img img{width:15px;height:15px;vertical-align: middle;}
.hotel-detail-info-mobile .hotel-data-info-bottom {padding:0px 10px;}
.hotel-detail-info-mobile .hotel-data-info-bottom .hotelFeesText /deep/ p{margin-block-start: 5px;margin-block-end: 5px;}
.hotel-detail-info-mobile .hotel-data-info-bottom .hotelFeesText /deep/ ul{margin-left:20px;margin-bottom: 10px;}

@media screen and (min-width: 1201px) {
.main{width:1100px;}
}
@media only screen and (min-width:1001px) and (max-width:1200px){
.main {width:95%;}
}
@media screen and (max-width: 1000px) {
.main {width:100%; margin: 0;}
.stepinfo{text-align: center; margin: 15px auto;}
.stepinfo /deep/ .el-steps{ width:360px !important; margin: 0 auto;}
.mobile-msg-main{margin:0px 10px;}
.el-step.is-center .el-step__line{left:30%;}
.el-step.is-center .step-two-zh{margin-right: 0px;left: 40%;right: -11%;}
.el-step.is-center .step-two-en{margin-right: 0px;right: -30%;left: 65%;}
.el-step.is-center .step-one-zh{margin-right: 0px;left: 40%;right: -11%;}
.el-step.is-center .step-one-en{margin-right: 0px;right: -30%;left: 65%;}
.step-text{font-size: 12px;}
.step-img{width:25px; height:25px;}
.step-text-zh{width:80px;}
.step-text-en{width:120px;}
.msg-orange{ font-size:12px;}
.mobile-msg-blue{height:50px;font-size: 12px;background-color: rgba(233, 238, 249, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); margin-bottom: 12px;}
.msg-right-all,.msg-left{clear:both; width:100%;margin:0px;}
.blue-tag,.orange-tag{float:left;}
.blue-text{width: 80%; line-height: 50px;margin-left: 10px;float: left;}
.orange-text{width:80%; line-height:25px;}
.blue-maintext,.orange-text,.email-maintext{padding:0px;}
.orange-text div{display: inline-block !important;}
.msg-lastname{width:100%;display:block;margin: 0;margin-bottom: 15px;}
.msg-username{width:100%;display:block;margin: 0; height:101px;}
.tonext{text-align:right; padding: 2px 4.5%;}
.order_button{width:100%;height:48px;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
.order_button:focus{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
.surplus-room{float:right;}
.msg-guest {margin-top:0; margin-bottom: 10px;}
.tax-dia .el-dialog__body{padding: 0px 15px 15px 15px !important;}
.tax-margin /deep/ .el-dialog{display: flex;flex-direction: column;margin:0 !important;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}
.tax-margin /deep/ .el-dialog .el-dialog__body{flex:1; overflow: auto;}
.remind-font{font-size:12px;}
.advanceText, .priceText{ font-size: 16px;}

/* 新步骤条 */
.order-step-new-zh{ display:inline-block; width: 48px;}
.order-step-new-en{display:inline-block; width: 80px; text-align:center;}
}
</style>



// WEBPACK FOOTER //
// src/components/order/bookingWriteOrder.vue